<script setup lang="ts">
import { ToastProvider, TooltipProvider } from 'reka-ui';
import { useRegisterSW } from 'virtual:pwa-register/vue';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouterView } from 'vue-router';
import ConfirmDialog from './components/dialog/ConfirmDialog.vue';
import { useConfirmDialog } from './composables/dialog/useConfirmDialog';
import NotificationLayout from './layout/NotificationLayout.vue';

const { t } = useI18n();
const { needRefresh, updateServiceWorker } = useRegisterSW({ immediate: true });
const { show: showConfirmDialog } = useConfirmDialog();

watch(needRefresh, (newValue) => {
  if (newValue) {
    showConfirmDialog({
      title: t('dialog.update-available.title'),
      message: t('dialog.update-available.message'),
      confirmText: t('dialog.update-available.confirm'),
      cancelText: t('dialog.update-available.cancel'),
      onConfirm: () => updateServiceWorker(true),
    });
  }
});
</script>

<template>
  <ToastProvider :duration="3000">
    <TooltipProvider>
      <RouterView />
      <NotificationLayout />
      <ConfirmDialog />
    </TooltipProvider>
  </ToastProvider>
</template>
